var _circle, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#B3261E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_993_8456",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_993_8456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 23.9249C15.5833 23.9249 15.2293 23.7793 14.938 23.488C14.646 23.196 14.5 22.8416 14.5 22.425C14.5 22.0083 14.646 21.6543 14.938 21.363C15.2293 21.071 15.5833 20.925 16 20.925C16.4167 20.925 16.7707 21.071 17.062 21.363C17.354 21.6543 17.5 22.0083 17.5 22.425C17.5 22.8416 17.354 23.196 17.062 23.488C16.7707 23.7793 16.4167 23.9249 16 23.9249ZM16 19.025C15.6167 19.025 15.2917 18.8916 15.025 18.625C14.7583 18.3583 14.625 18.0333 14.625 17.65V8.94995C14.625 8.56662 14.7627 8.24162 15.038 7.97495C15.3127 7.70828 15.6333 7.57495 16 7.57495C16.3833 7.57495 16.7083 7.70828 16.975 7.97495C17.2417 8.24162 17.375 8.56662 17.375 8.94995V17.65C17.375 18.0333 17.2377 18.3583 16.963 18.625C16.6877 18.8916 16.3667 19.025 16 19.025Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.ba924bba525bb403722332dd3cf93e50.svg";
export { ForwardRef as ReactComponent };